// -----------------------------------------------------------------------
// <copyright file="EmeraldUserType.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum EmeraldUserType {
  Consumer = 'Consumer',
  Commercial = 'Commercial',
}
